import MaterialTable, { MTableToolbar } from "material-table";
import React from "react";
import { makeStyles } from "@mui/styles";
import AddIcon from '@mui/icons-material/Add';

const blue500 = "#2a479ed9"
const blue300 = "#c8d7e3"
const blue100 = "#e0ecf7"

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      "& :hover, .Mui-active, .MuiTableSortLabel-icon": {
        color: blue500,
      }
    },
    "& tbody": {
      "& .MuiTableRow-root:hover": {
        backgroundColor: blue100,
      }
    },
    "& .MuiTablePagination-toolbar": {
      "& p": {
        margin: 0,
      },
    },
  },
  highlight: {
    backgroundColor: blue500,
    "& *": {
      color: "white",
    },
  },

});


const Table = ({
  loading,
  id,
  columns,
  data,
  title,
  onRowClick,
  editable,
  onSearchChange,
  onRowSelected,
  paging,
  search,
  selection,
  maxHeight,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <br />
      <MaterialTable
        isLoading={loading}
        components={{
          Toolbar: (_props) => (
            <MTableToolbar
              classes={{ highlight: classes.highlight }}
              {..._props}
            />
          ),
        }}
        icons={{
          Add: () => <AddIcon style={{ color: 'blue' }} />,
        }}
        id={id}
        columns={columns}
        data={data}
        title={title}
        onRowClick={onRowClick}
        editable={editable}
        onSearchChange={onSearchChange}
        onRowSelected={onRowSelected}
        options={{
          paging: paging != null ? paging : (data.length > 10 ? true : false),
          pageSize: 10,
          search: search != null ? search : true,
          headerStyle: {
            backgroundColor: blue300,
          },
          rowStyle: (rowData) => ({
            backgroundColor: rowData.tableData.checked ? blue500 : "",
            color: rowData.tableData.checked ? "white" : "",
          }),
          selection: selection,
        }}
        style={{
          display: "grid",
          gridTemplateColums: "1fr",
          gridTemplateRows: "auto 1fr auto",
          maxHeight,
        }}
      />
    </div>
  )
}

export default Table;